module.exports = __webpack_public_path__ + "img/reference18.eb59297b.jpg";